import React, { useState } from "react";
// import { formatDate } from "../../helper/index"
import HistoryModel from "../HistoryModal";
import { fetchReplacedMarketBetBuilder } from "../../api/api";
import { totalOddsCal, formatValue } from "../../helper/index"

const BETWAY_URL = process.env.REACT_APP_BETWAY;


const InstantbetData = ({
  topBestBet,
  totalodds,
  stake,
  isLoadingSearchData,
  handleStakeChange,
  setTotalodds,
  oddsFormat,
  isleg,
  language,

}) => {
  const [showHistory, setShowHistory] = useState(null);
  const [excludeMarketId, setExcludeMarketId] = useState();
  const [alert, setAlert] = useState("");

  const handleOpenModal = (index) => {
    setShowHistory(index);
  };

  const handleCloseModal = () => {
    setShowHistory(null);
  };

  const modifyWinLossStatus = (val) => {
    return val ? val.split(",") : [];
  };

  const handleBetBuilderRefresh = async (j, excludeMarketId, matchid) => {
    setExcludeMarketId(excludeMarketId);
    const filterIncludeMarketId = () => {
      const allMarketIds = topBestBet.flatMap((item) =>
        item.bestbet
          .filter((betItem) => betItem.marketid !== excludeMarketId)
          .map((betItem) => betItem.marketid)
      );
      const includeMarketIdString = allMarketIds.join(",");
      return includeMarketIdString; // Return value for synchronous use
    };

    const fetchReplaceData = async (includeMarketId) => {
      try {
        const data = await fetchReplacedMarketBetBuilder(
          1,
          matchid,
          excludeMarketId,
          4,
          excludeMarketId,
          includeMarketId,
          language
        );
        const resData = data.data;
        if (resData) {
          const indexToReplace = topBestBet[0].bestbet.findIndex(
            (item) => item.marketid === excludeMarketId
          );
          if (indexToReplace !== -1) {
            const randomIndex = Math.floor(Math.random() * resData.length);
            topBestBet[0].bestbet[indexToReplace] = resData[randomIndex];
          }
        } else {
          setAlert("No replacement available");
          setTimeout(() => {
            setAlert("");
          }, 3000);
        }
        const totalOdds = totalOddsCal(oddsFormat, topBestBet[0].bestbet)
        setTotalodds(totalOdds);
      } catch (error) {
        console.error("Error fetching or updating data:", error);
      } finally {
        // Reset `refreshNo` after a delay
        console.log("done");
      }
    };

    const includeMarketId = filterIncludeMarketId();
    if (includeMarketId.length > 0) {
      await fetchReplaceData(includeMarketId);
    }
  };

  return (
    <div>
      {topBestBet.length > 0 ? (
        <div className="AF-widget__content">
          <div className="AF-matchBoxGroup clearfix">
            {topBestBet.map((bet, betIndex) =>
              bet.bestbet?.map((item, itemIndex) => {
                const status = modifyWinLossStatus(item.form);
                const grading = item.grading * 10
                const radius = 20;
                const circumference = 2 * Math.PI * radius;
                const progress = Math.max(0, Math.min(100, parseFloat(grading)));
                const offset = circumference * (1 - progress / 10);
                return (
                  <div className="AF-matchBoxGroup__item matchbox_instant">
                    <div className="AF-matchBox">
                      {alert && item.marketid === excludeMarketId ? (
                        <div className="loading-container">
                          <div className="error-text">{alert}</div>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="AF-matchBox__header instant_header">
                        <div className="grid-noGutter">
                          <div className="col-8">
                            {item.bestbetname || "League Name"}
                          </div>
                          <div className="col-4 text-right">
                            <span className="refresh-icon-instant">
                              <svg
                                className="instant_icon"
                                viewBox="0 0 30 30"
                                id="referesh_instance_bet"
                                onClick={() =>
                                  handleBetBuilderRefresh(
                                    itemIndex,
                                    item.marketid,
                                    bet.matchid
                                  )
                                }
                              >
                                <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"></path>
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="AF-matchBox__content">
                        {/* <div className="AF-matchBox__fixture truncate">{bet.matchname || "Match Name"}</div> */}
                        {/* <div className="AF-matchBox__fixture AF-matchBox__fixture_new truncate">
                                    <span className="match-name">{bet.matchname || "Match Name"}</span>
                                    <span className="refresh-icon">
                                        <svg className="icon" viewBox="0 0 30 30" onClick={() => handleBetBuilderRefresh(itemIndex, item.marketid,bet.matchid )}>
                                            <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"></path>
                                        </svg>
                                    </span>
                                </div> */}
                        <div className="AF-matchBox__RTB-instant">
                          <div className="AF-matchBox__fixture_new">
                            <div className="column rtb-status-instant">{item.rtb || "RTB"}</div>
                            {item.odds.decimalodds === '1.01' || item.odds.decimalodds === null || item.odds.decimalodds === '1.010' || item.odds.decimalodds == 0 || item.odds.decimalodds === 1.010 ? 
                              <div className="email-error-msg">Odds currently unavailable</div>
                              :
                            <>
                              <div className="column button-container-instant">
                                <button className="btn-accordion">
                                  {oddsFormat === "EU"
                                    ? parseFloat(item.odds.decimalodds).toFixed(2)
                                    : formatValue(item.odds.americanodds)}
                                </button>
                              </div>
                              <div className="column progress-container-instant">
                                <div className="tooltip-wrapper-new">
                                  <div className="circular-progress">
                                      <span className="progress-value">
                                        {parseFloat(grading.toFixed(1))}
                                      </span>
                                      <svg className="progress-circle" viewBox="0 0 50 50">
                                        <circle
                                          className="progress-bg"
                                          cx="25"
                                          cy="25"
                                          r="20"
                                        />
                                        <circle
                                          className="progress-bar"
                                          cx="25"
                                          cy="25"
                                          r="20"
                                          strokeDasharray={circumference}
                                          strokeDashoffset={offset}
                                        />
                                      </svg>
                                  </div>
                                  {/* <div className="circular-progress">
                                    <span className="progress-value">
                                      {parseFloat(grading.toFixed(2))}
                                    </span>
                                    <svg
                                      className="progress-circle"
                                      viewBox="0 0 50 50"
                                    >
                                      <circle
                                        className="progress-bg"
                                        cx="25"
                                        cy="25"
                                        r="20"
                                      />
                                      <circle
                                        className="progress-bar"
                                        cx="25"
                                        cy="25"
                                        r="20"
                                        style={{ "--progress": 1 }}
                                      />
                                    </svg>
                                  </div> */}
                                  <span className="tooltip-text-new">
                                    Strength score (0–10) based on stat frequency & odds value. Higher = better.
                                  </span>
                                </div>
                              </div>
                            </>
                            }
                          </div>
                          <div
                            className="win_loss_status2"
                            onClick={() => handleOpenModal(itemIndex)}
                            id="modal_win_loss_instance_bet"
                          >
                            {status.map((statusItem, j) => (
                              <React.Fragment key={j}>
                                {j <= 5 &&
                                  (statusItem === "W" ? (
                                    <span className={`win_loss_badge win`}>
                                      W
                                    </span>
                                  ) : statusItem === "L" ? (
                                    <span className={`win_loss_badge loss`}>
                                      L
                                    </span>
                                  ) : (
                                    <span className={`win_loss_badge draw`}>
                                      D
                                    </span>
                                  ))}
                              </React.Fragment>
                            ))}
                          </div>
                        </div>

                        {showHistory === itemIndex && item.history && (
                          <div>
                            <HistoryModel
                              onClose={handleCloseModal}
                              onClick={handleOpenModal}
                              history={item.history}
                              play="soccer"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
          <div className="AF-widget__footer p-0">
            <div className="grid-middle-noGutter">
              <div className="col-6_lg-6_md-6_sm-6_xs-6">
                <ul className="AF-totalOdds-stake-earn">
                  <li className="instant_lags">
                    <div className="AF-stake">
                      <span className="int-leg">Legs: </span>
                      <div className="AF-formControl">
                        <select
                          className="big-select"
                          onChange={handleStakeChange}
                          value={stake}
                          id="select-instant-bet-legs"
                        >
                          {(isleg ? [2, 3, 4, 5, 6] : [2, 3, 4]).map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </div>
                      <span className="tooltip-wrapper">
                        <span className="info-icon-int">ℹ</span>
                        <span className="tooltip-text">Click to replace this pick with another strong option.</span>
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="col-6_lg-6_md-6_sm-6_xs-6">
                <div className="AF-addAllToBetslip__btn-insta">
                  <a
                    href={BETWAY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{textDecoration:'none', color:'#fff'}}
                  >
                  
                  <ul className="AF-addAllToBetslip">
                    <li className="tooltip-wrapper">
                      <span className="odds_font_size">{totalodds}</span>
                      <span className="tooltip-text">
                        Estimated odds, not official. Prices may differ; guidance only (not true/value odds).
                      </span>
                    </li>
                  </ul>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : isLoadingSearchData ? (
        <div className="loading-container">
          {/* <div className="AF-error-message">No data available</div> */}
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="AF-error-message">No data available</div>
      )}
    </div>
  );
};

export default InstantbetData;
